import { render, staticRenderFns } from "./BranchSelect.vue?vue&type=template&id=39c4ce68&"
import script from "./BranchSelect.vue?vue&type=script&lang=js&"
export * from "./BranchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports